import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { theme } from './theme/theme';
import { AuthProvider, ProtectedRoute } from './contexts/AuthContext';
import { NotificationsProvider } from './contexts/NotificationsContext';
import Dashboard from './components/Dashboard';
import Chat from './components/Chat';
import Schedule from './components/Schedule';
import Debug from './components/Debug';
import ClientManagement from './components/ClientManagement';
import ClientDetail from './components/ClientDetail';
import EmployeeManagement from './components/EmployeeManagement';
import EmployeeDetail from './components/EmployeeDetail';
import ProjectManagement from './components/ProjectManagement';
import WorkActivityManagement from './components/WorkActivityManagement';
import WorkActivityDetail from './components/WorkActivityDetail';
import WorkActivityReviewFlow from './components/WorkActivityReviewFlow';
import { NotionSync } from './components/NotionSync';
import Admin from './components/Admin';
import Navigation from './components/Navigation';
import Login from './components/Login';
import NotionEmbedPage from './components/NotionEmbedPage';
import QuickBooksIntegration from './components/QuickBooksIntegration';
import Invoices from './components/Invoices';
import InvoiceReview from './components/InvoiceReview';
import Settings from './components/Settings';
import Reports from './components/Reports';
import NaturalLanguageSQL from './components/NaturalLanguageSQL';
import Notifications from './components/Notifications';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <AuthProvider>
          <NotificationsProvider>
            <Router>
              <div className="App">
                <Routes>
                  <Route path="/login" element={<Login />} />
                  <Route path="/notion-embed" element={<NotionEmbedPage />} />
                  <Route path="/*" element={
                    <ProtectedRoute>
                      <Navigation />
                      <Routes>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/review" element={<WorkActivityReviewFlow />} />
                        <Route path="/chat" element={<Chat />} />
                        <Route path="/schedule" element={<Schedule />} />
                        <Route path="/clients" element={<ClientManagement />} />
                        <Route path="/clients/:id" element={<ClientDetail />} />
                        <Route path="/employees" element={<EmployeeManagement />} />
                        <Route path="/employees/:id" element={<EmployeeDetail />} />
                        <Route path="/projects" element={<ProjectManagement />} />
                        <Route path="/work-activities" element={<WorkActivityManagement />} />
                        <Route path="/work-activities/:id" element={<WorkActivityDetail />} />
                        <Route path="/notion-sync" element={<NotionSync />} />
                        <Route path="/notifications" element={<Notifications />} />
                        <Route path="/quickbooks" element={<QuickBooksIntegration />} />
                        <Route path="/invoices" element={<Invoices />} />
                        <Route path="/invoices/review" element={<InvoiceReview />} />
                        <Route path="/reports" element={<Reports />} />
                        <Route path="/ask-data" element={<NaturalLanguageSQL />} />
                        <Route path="/debug" element={<Debug />} />
                        <Route path="/settings" element={<Settings />} />
                        <Route path="/admin" element={<Admin />} />
                      </Routes>
                    </ProtectedRoute>
                  } />
                </Routes>
              </div>
            </Router>
          </NotificationsProvider>
        </AuthProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App; 